import { parseUserSetting } from '../../utils/userSetting';

app.service('settingService', [
  'mainConfig',
  function (mainConfig) {
    const getUserSettingFromMainConfig = () =>
      parseUserSetting(mainConfig.merchantData?.user_setting?.data ?? {});

    return { getUserSettingFromMainConfig };
  },
]);
